import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";
import { englishTheme, arabicTheme } from "./styles/theme";
import { Home } from "./pages/Home";
import MainLayout from "./components/layout/MainLayout";
import { useTranslation } from "react-i18next";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Services from "./pages/Services";
import ScrollToTop from "./components/shared/ScrollToTop";
import { Provider } from "react-redux";
import store from "./redux/store";
import ToastNotification from "./components/shared/ToastNotification";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const { i18n } = useTranslation();
  const currentTheme = i18n.language === "ar" ? arabicTheme : englishTheme;
  const langPrefix = i18n.language || localStorage.getItem("language") || "en";
  return (
    <Provider store={store}>
      <ThemeProvider theme={currentTheme}>
        <CssBaseline />
        <Router>
          <ScrollToTop />
          <MainLayout>
            <Routes>
              <Route
                path="/"
                element={<Navigate to={`/${langPrefix}`} replace />}
              />
              <Route path={`/${langPrefix}`} element={<Home />} />
              <Route path={`/${langPrefix}/about`} element={<About />} />
              <Route path={`/${langPrefix}/services`} element={<Services />} />
              <Route path={`/${langPrefix}/contact`} element={<Contact />} />
              <Route
                path="*"
                element={<Navigate to={`/${langPrefix}`} replace />}
              />
            </Routes>
          </MainLayout>
        </Router>
        <ToastNotification />

      </ThemeProvider>
    </Provider>
  );
}

export default App;
